<template>
  <div class="realEstate">

    <div class="edit-area">

      <h2 class="normal">地铁线路</h2>

      <div class="edit-area-content">
        <el-button @click="reverseLine" type="info">反转</el-button>
        <el-button @click="sortStations" type="info">站点排序</el-button>
        <button @click="jiadian = !jiadian" :class="{'bgred': jiadian}">加点</button>
        <div class="normal">几期：<input type="text" v-model="stage"></div>
        <div class="normal">线路名：<input type="text" v-model="name"></div>
        <div>状态：
          <el-select v-model="codeType" clearable>
            <el-option value="规划">规划</el-option>
            <el-option value="远期">远期</el-option>
          </el-select>
        </div>
        <div class="normal">
          模式
          <button @click="changeMode('地铁站')" :class="{'bgred': mode === '地铁站'}">地铁站</button>
          <button @click="changeMode('线路名')" :class="{'bgred': mode === '线路名'}">线路名</button>
        </div>
        <div v-if="stationList.length > 0">共{{stationList.length}}个站</div>
        <div class="normal" v-for="(station,index) in stationList" :key="index" @click="changeCenter(station)">
          <div>站名:<span :style="{'background-color': station.goto?'yellow':'white'}">{{station.name}}</span></div>
          <button @click.stop="del(index)">删除</button>
          <button @click.stop="rename1(index)">修改</button>
          <button @click.stop="toTop(index)">置顶</button>
          <button @click.stop="toLocation(index)">去编辑</button>
          <div v-if="showRenameInput === index">
            <input type="text" v-model="station.name" @keydown.enter="rename2(index)" @click.stop v-focus
              @blur="loseFocus">
          </div>
        </div>

        <button @click="upToDb" class="up">上传数据库</button>

      </div>

    </div>

    <div id="subway_container" :style="mapHeight">
      <!-- <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult"></el-amap-search-box> -->
      <el-amap class="amap-box" vid="real_map" ref="real_map" :zoom="zoom" :center="center" :amap-manager="amapManager"
        :plugin="plugin" :events="events">
        <el-amap-polyline editable=false :path="dots" strokeColor="blue" strokeWeight=2></el-amap-polyline>
        <!-- <el-amap-marker :vid="'real_search_marker' + index" v-for="(marker,index) in markers" :key="index" :position="[marker.lng,marker.lat]" :events="searchMarkerEvents"></el-amap-marker> -->
        <el-amap-marker :vid="'lnglat_marker' + index" v-for="(pos,index) in lnglatObj" :key="index"
          :position="pos.split('|')" :events="lnglatMarkerEvents" icon='./../../static/images/marker1.png'
          :draggable="true" :offset=[-16,-27]></el-amap-marker>
        <el-amap-marker :vid="'station_marker' + index" v-for="(pos,index) in stationList" :key="'station' + index"
          :position="pos.position" :events="stationMarkerEvents" icon="./../../static/images/marker.png" zIndex=101
          :draggable="true" :offset=[-16,-27] :label="{'content': pos.name, 'offset': [15, -5]}"></el-amap-marker>
        <el-amap-marker :vid="'name_marker' + index" v-for="(pos,index) in mark" :key="'name' + index" zIndex=102
          :position="pos.split('|')" :events="nameMarkerEvents" icon="./../../static/images/notdb.png"
          :draggable="true" :offset=[-16,-27]></el-amap-marker>
      </el-amap>
    </div>

  </div>
</template>

<script>
  import {
    AMapManager
  } from "vue-amap"
  let amapManager = new AMapManager();
  export default {
    data() {
      return {
        name: '',  // 线路名
        subway_id: '',
        lnglatObj: [], //画点的
        dots: [], //画线的
        stationList: [], //站点
        showRenameInput: '',
        dragging: null,

        location_size: '',
        location_type: '商场',
        school_type: '小学',
        private_public: '公办',

        mapHeight: {},

        searchOption: {
          city: '杭州',
          citylimit: true
        },
        zoom: 15,
        center: [120.051238, 30.228232],
        amapManager,
        events: {
          'rightclick': (e) => {
            let that = this
            let dot = [e.lnglat.lng, e.lnglat.lat]
            let lnglat = dot.join('|');
            if (that.jiadian) {
              let cindex = -1;
              let mdis;
              that.lnglatObj.forEach((x,i) => {
                let dis = that.getClosestDot(x, lnglat).distance;
                if (mdis) {
                  if (dis < mdis) {
                    mdis = dis;
                    cindex = i;
                  }
                } else {
                  mdis = dis;
                  cindex = i;
                }
              })
              if (mdis) {
                that.dots.splice(cindex,0,dot)
                that.lnglatObj.splice(cindex,0,lnglat)
              }
            } else {
              that.dots.push(dot)
              that.lnglatObj.push(lnglat)
            }
          },
          'click': (e) => {
            let that = this
            let dot = [e.lnglat.lng, e.lnglat.lat]
            if (that.mode === '地铁站') {
              that.stationList.push({
                position: dot,
                name: '未命名地铁站'
              })
            } else {
              that.mark.push(dot.join('|'))
            }
          }
          
        },
        plugin: [{
          //地图类型，卫星地图和普通地图
          pName: 'MapType',
          defaultType: 0,
        }],
        markers: [],

        lnglatMarkerEvents: {
          'rightclick': (e) => {
            let that = this
            let index = e.target.w.vid.replace('lnglat_marker', '')
            that.dots.splice(index, 1)
            that.lnglatObj.splice(index, 1)
          },
          'click': (e) => {
            let that = this
            let index = Number(e.target.w.vid.replace('lnglat_marker', ''))
            console.log('index', index)
            let dot = that.lnglatObj[index].split('|')
            if (that.mode === '地铁站') {
              that.stationList.push({
                position: dot,
                name: '未命名地铁站'
              })
            } else {
              that.mark.push(that.lnglatObj[index])
            }
          },
          'dragging': (e) => {
            let that = this
            let index = e.target.w.vid.replace('lnglat_marker', '')
            let dot = [e.lnglat.lng, e.lnglat.lat]
            that.dots.splice(index, 1, dot)
            that.lnglatObj.splice(index, 1, dot.join('|'))
          }
        },
        stationMarkerEvents: {
          'rightclick': (e) => {
            let that = this
            let index = e.target.w.vid.replace('station_marker', '')
            that.stationList.splice(index, 1)
            console.log('index', index);
          },
          'dragging': (e) => {
            let that = this
            let index = e.target.w.vid.replace('station_marker', '')
            let dot = [e.lnglat.lng, e.lnglat.lat]
            let old = JSON.parse(JSON.stringify(that.stationList[index]))
            old.position = [e.lnglat.lng, e.lnglat.lat]
            that.stationList.splice(index, 1, old)
          }
        },
        nameMarkerEvents: {
          'rightclick': (e) => {
            let that = this
            let index = e.target.w.vid.replace('name_marker', '')
            console.log('index', index);
            that.mark.splice(index, 1)
          }
        },

        mode: '地铁站',  // 当前模式是标记地铁站还是标识线路名

        mark:[],  //标记线路名的点的 index 放这里

        stage: '',

        jiadian: false,
        
        modelMap: {
          '杭州': 'SubwayModel',
          '苏州': 'SzSubwayModel',
          '天津': 'TjSubwayModel',
          '绍兴': 'SxSubwayModel',
          '宁波': 'NbSubwayModel',
        },

        hasCover: false,
        codeType: ''
      }
    },
    created() {
      let height = window.innerHeight + 'px';
      console.log(height)
      this.mapHeight.height = height
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        delete origin.mapHeight;
        delete origin.events;
        delete origin.lnglatMarkerEvents;
        delete origin.stationMarkerEvents;
        delete origin.nameMarkerEvents;
        delete origin.hasCover;
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {
      init() {
        let that = this;
        let obj = that.$route.params
        let city = that.$store.state.Counter.city;
        if (city === '苏州') {
          that.center = [120.585197,31.299473];
        } else if (city === '天津') {
          that.center = [117.201538,39.085294];
        } else if (city === '绍兴') {
          that.center = [120.582886,30.051549];
        } else if (city === '宁波') {
          that.center = [121.6216,29.859515];
        }
        console.log('obj', obj)
        if (obj.id) {
          that.$axios.get(that.$url_prefix + 'queryOneById', {
            params: {
              id: obj.id,
              db: that.modelMap[city]
            }
          }).then(function (res) {
            console.log('query back',res)
            let one = res.data.data;
            if (one.mark) {
              that.mark = one.mark.split('-');
            }
            that.name = one.name
            that.stage = one.stage || ''
            that.subway_id = one.id
            that.lnglatObj = one.dots.split('-')
            let temp = one.dots.split('-')
            for (let i = 0; i < temp.length; i++) {
              temp[i] = temp[i].split('|')
            }
            that.dots = temp
            that.stationList = JSON.parse(one.station)
            console.log('stationList', that.stationList);
            that.center = that.dots[0]
            that.codeType = one.status || ''

            if (!that.hasCover && city === '苏州') {
              let currentMap = amapManager.getMap();
              let imageLayer = new AMap.ImageLayer({
                url: 'https://www.xaoji.com/upload/image/suzhou_subway.png?v=1',
                bounds: new AMap.Bounds([120.2457, 31.055171], [121.035342, 31.553849]),
                zooms: [12, 25],
                opacity: 1,
                map: currentMap,
                zIndex: 100
              });
            }
            // if (!that.hasCover && city === '杭州') {
            //   let currentMap = amapManager.getMap();
            //   let imageLayer = new AMap.ImageLayer({
            //     url: 'https://www.xaoji.com/upload/image/hangzhou_subway.png?v=1',
            //     bounds: new AMap.Bounds([119.629681, 29.965724], [120.762647, 30.588354]),
            //     zooms: [12, 25],
            //     opacity: 1,
            //     map: currentMap,
            //     zIndex: 100
            //   });
            // }

          }).catch(function (res) {
            console.log('err', res)
            alert('查询失败，请检查网络')
          })

        } else {
          console.log('没有信息')
        }

      },
      //地图搜索的回调
      onSearchResult(pois) {
        if (pois.length > 0) {
          let {
            lng,
            lat
          } = pois[0];
          this.markers = pois;
          this.center = [lng, lat];

        }
      },


      //上传数据库
      upToDb() {
        let that = this

        let obj = {}

        if (that.name.length === 0) {
          alert('请填写几号线')
          return;
        }
        if (that.lnglatObj.length === 0) {
          alert('没有线路数据')
          return;
        }
        if (that.stationList.length === 0) {
          alert('没有站点')
          return;
        }
        if (that.mark.length > 0) {
          obj.mark = that.mark.join('-');
        } else {
          obj.mark = ''
        }
        obj.name = that.name;
        obj.stage = that.stage;
        obj.status = that.codeType;
        obj.dots = that.lnglatObj.join('-')
        obj.station = JSON.stringify(that.stationList)

        if (that.subway_id.length > 0) {
          obj.id = that.subway_id
        }

        let param = {
          'db': that.modelMap[that.$store.state.Counter.city],
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (want) {
          console.log('update back', want)
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('update fail', res);
        })

      },

      changeCenter(station) {
        this.center = station.position
      },
      del(index) {
        let temp = this.stationList.splice(index, 1)[0]
      },
      rename1(index) {
        let that = this
        that.showRenameInput = index
        // that.renameText = that.tagList[index].name
      },
      rename2(index) {
        let that = this
        // that.tagList[index].name = that.renameText
        that.showRenameInput = ''
      },
      loseFocus() {
        this.showRenameInput = ''
      },

      changeMode(mode){
        this.mode = mode;
      },

      reverseLine() {
        this.lnglatObj.reverse();
        this.dots.reverse();
        this.$message({
          message: '反转成功',
          type: 'success'
        })
      },

      sortStations() {
        let stationList = JSON.parse(JSON.stringify(this.stationList));
        let list = [];
        list.push(stationList.splice(0,1)[0]);
        
        while (stationList.length > 0) {
          let last = list[list.length - 1];
          let minDis = 1000000;
          let minIndex = -1;
          for (let i=0; i<stationList.length; i++) {
            let dis = AMap.GeometryUtil.distance(stationList[i].position, last.position);
            if (dis < minDis) {
              minDis = dis;
              minIndex = i;
            }
          }
          if (minIndex > -1) {
            list.push(stationList.splice(minIndex,1)[0]);
          } else {
            console.log('err');
            return;
          }
        }
        if (JSON.stringify(list) === JSON.stringify(this.stationList)) {
          this.$message({
            type: 'success',
            message: '已经是正确顺序'
          })
        } else {
          this.stationList = list;
          this.$message({
            type: 'success',
            message: '排序成功'
          })
        }
        console.log('sort over');
      },

      toTop(index) {
        this.stationList.unshift(this.stationList.splice(index,1)[0]);
        this.$message({
            type: 'success',
            message: '置顶成功'
          })
      },

      getClosestDot(a, b) {
        let lista = a.split('-')
        let listb = b.split('-')
        let dota = lista[0].split('|')
        let dotb = listb[0].split('|')
        let distance = this.getDistance(Number(dota[1]), Number(dota[0]), Number(dotb[1]), Number(dotb[0]))
        for (let i = 0; i < lista.length; i++) {
          for (let j = 0; j < listb.length; j++) {
            let pointa = lista[i].split('|')
            let pointb = listb[j].split('|')
            let temp = this.getDistance(Number(pointa[1]), Number(pointa[0]), Number(pointb[1]), Number(pointb[
              0]))
            if (temp < distance) {
              distance = temp
              dota = pointa
              dotb = pointb
            }
          }
        }
        return {
          a: dota,
          b: dotb,
          distance: parseInt(distance)
        }
      },
      getDistance(lat1, lng1, lat2, lng2) {
        let EARTH_RADIUS = 6378137.0; //单位M
        let f = this.getRad((lat1 + lat2) / 2);
        let g = this.getRad((lat1 - lat2) / 2);
        let l = this.getRad((lng1 - lng2) / 2);

        let sg = Math.sin(g);
        let sl = Math.sin(l);
        let sf = Math.sin(f);

        let s, c, w, r, d, h1, h2;
        let a = EARTH_RADIUS;
        let fl = 1 / 298.257;

        sg = sg * sg;
        sl = sl * sl;
        sf = sf * sf;

        s = sg * (1 - sl) + (1 - sf) * sl;
        c = (1 - sg) * (1 - sl) + sf * sl;

        w = Math.atan(Math.sqrt(s / c));
        r = Math.sqrt(s * c) / w;
        d = 2 * w * a;
        h1 = (3 * r - 1) / 2 / c;
        h2 = (3 * r + 1) / 2 / s;

        return d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg));
      },
      getRad(d) {
        let PI = Math.PI;
        return d * PI / 180.0;
      },

      toLocation(index) {
        let that = this;
        let item = this.stationList[index];
        let query = {
          position: item.position,
          from: 'subway'
        }
        if (item.id) {
          query.id = item.id;
        }
        let routeData = this.$router.resolve({
          path: "location",
          query: query
        });
        window.open(routeData.href, '_blank');
      }

    }
  }

</script>

<style scoped>

  .realEstate {
    display: flex;
    width: 100%;
    user-select: none;
  }

  .realEstate .edit-area {
    text-align: center;
    width: 30%;
  }

  .realEstate #subway_container {
    width: 70%;
    position: fixed;
    top: 0;
    left: 30%;
  }

  #subway_container .search-box {
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid black;
  }

  .imageBox {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
  }

  .imageBox .imageItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
  }

  img {
    height: 100px;
    width: 100px;
    vertical-align: bottom;
  }

  .up {
    margin-top: 20px;
    width: 150px;
    height: 50px;
    border-radius: 10px
  }

  .adImg {
    height: 100px;
  }

  .line {
    margin-top: 20px;
    color: #ccc;
  }

  .normal {
    margin: 10px 0;
  }

  .white {
    height: 50px;
  }

  .salesmanList {
    display: flex;
    flex-wrap: wrap;
  }

  .salesman {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 20px;
  }

  .salesman img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  .bgred{
    background-color: red;
  }

</style>



// WEBPACK FOOTER //
// src/page/subway.vue